module.exports = __webpack_public_path__ + "media/Instruction_B43.b7b4c912.mp3";